var handleAuthCodeError = function handleAuthCodeError(error) {
  switch (error.error) {
    case 'login_required':
    case 'interaction_required':
    case 'account_selection_required':
    case 'consent_required':
      return {
        error: 'login_required',
        error_description: 'User interaction is required'
      };

    case 'temporarily_unavailable':
      return {
        error: 'unavailable'
      };

    case 'invalid_request':
    case 'unauthorized_client':
    case 'unsupported_response_type':
    case 'invalid_scope':
      return {
        error: 'client_error',
        error_description: JSON.stringify(error)
      };

    case 'server_error':
    default:
      return {
        error: 'unknown_error'
      };
  }
};

export default handleAuthCodeError;